import type { CardIdentity, MatchCandidate } from '@/lib/cardMatching';

/**
 * Stub for future card matching.
 *
 * TODAY: always returns an empty list. The fast-add row in `ItemFormModal`
 * calls this hook and renders nothing because `candidates.length === 0`.
 *
 * FUTURE: wire this to `scrydexMatcher` (memory:
 * `scrydex-matching-workbench-v1`) — query Scrydex by title/set/number,
 * map results to `MatchCandidate[]`, return them. The fast row's hidden
 * `MatchCandidateSlot` lights up automatically. On candidate tap, autofill
 * `set_name`, `card_number`, `image_url` and stash `scrydex_id` so
 * `pricingOrchestrator` can pull live prices.
 *
 * Keep this hook's signature stable so the UI seam doesn't have to change
 * when the matcher lands.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useCardMatchCandidates(_identity: CardIdentity): {
  candidates: MatchCandidate[];
  isLoading: boolean;
  isReady: boolean;
} {
  return { candidates: [], isLoading: false, isReady: false };
}
